import { useQuery, QueryFunction } from 'react-query';
import {
    getAllVersionNotes,
    getCurrentVersionNote,
    VersionNotesResponse,
    VersionNoteResponse,
    GetAllVersionNotesParams,
} from '../../services/apiSLTP/versionNotes';

type UseVersionNotesQueryOptions = {
    queries?: GetAllVersionNotesParams;
};

type UseCurrentVersionNoteQueryOptions = {};

const getVersionNotes: QueryFunction<VersionNotesResponse> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseVersionNotesQueryOptions];
    const { queries } = options;
    try {
        const versionNotes = await getAllVersionNotes(queries);
        return versionNotes;
    } catch (error) {
        throw new Error('An unexpected error occurred while fetching version notes');
    }
};

const getCurrentVersion: QueryFunction<VersionNoteResponse> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseCurrentVersionNoteQueryOptions];
    try {
        const CurrentVersionNote = await getCurrentVersionNote();
        return CurrentVersionNote;
    } catch (error) {
        throw new Error('An unexpected error occurred while fetching the Current version note');
    }
};

export const useVersionNotesQuery = (options: UseVersionNotesQueryOptions) => {
    return useQuery(['VersionNotes', options], getVersionNotes);
};

export const useCurrentVersionNoteQuery = (options: UseCurrentVersionNoteQueryOptions) => {
    return useQuery(['CurrentVersionNote', options], getCurrentVersion);
};
